import { Suspense, type ReactNode } from "react";
import { Loader2 } from "lucide-react";

// Wraps the routed page inside Layout and ResearchLayout. While a page's lazy
// chunk loads, only the content area shows a spinner, so the sidebar and top bar
// stay on screen. Without it, the nearest boundary is the one in App.tsx, which
// covers the whole screen and looks like a full page reload.
const PageContentSuspense = ({ children }: { children: ReactNode }) => (
  <Suspense
    fallback={
      <div
        role="status"
        className="flex items-center justify-center min-h-[400px]"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    }
  >
    {children}
  </Suspense>
);

export default PageContentSuspense;
